import React, { useState, useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { Button } from '../components/ui/button';
import api from '../lib/api';
import SEO from '../components/SEO';
import { prepareContent } from '../lib/content';

export default function LegalPage() {
  const { slug } = useParams();
  const [page, setPage] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    setPage(null);
    api.get(`/legal/${slug}`, { params: { _t: Date.now() } })
      .then(r => { setPage(r.data); setLoading(false); })
      .catch(() => setLoading(false));
  }, [slug]);

  if (loading) {
    return (
      <div className="min-h-[60vh] flex items-center justify-center">
        <div className="animate-pulse w-full max-w-2xl px-4 space-y-4">
          <div className="h-8 bg-[#E2E8F0] rounded w-1/2" />
          <div className="h-4 bg-[#E2E8F0] rounded" />
          <div className="h-4 bg-[#E2E8F0] rounded w-3/4" />
        </div>
      </div>
    );
  }

  if (!page) {
    return (
      <div className="min-h-[60vh] flex items-center justify-center">
        <div className="text-center">
          <h2 className="text-2xl font-['Outfit'] font-semibold text-[#0B1B3D]">Oldal nem található</h2>
          <Link to="/" className="inline-block mt-4">
            <Button variant="outline" className="border-[#0B1B3D] text-[#0B1B3D]">
              <ArrowLeft className="mr-2" size={16} /> Főoldal
            </Button>
          </Link>
        </div>
      </div>
    );
  }

  return (
    <div data-testid="legal-page">
      <SEO
        title={page.title}
        description={`${page.title} – AGM Consulting jogi dokumentum.`}
        path={`/jogi/${page.slug}`}
      />
      <section className="py-16 sm:py-20 bg-[#0B1B3D]">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <h1 className="text-3xl sm:text-4xl font-['Outfit'] font-semibold text-white">{page.title}</h1>
          {page.updated_at && (
            <p className="mt-3 text-sm text-[#94A3B8]">
              Utolsó frissítés: {new Date(page.updated_at).toLocaleDateString('hu-HU')}
            </p>
          )}
        </div>
      </section>
      <section className="py-12 sm:py-16 bg-white">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div
            className="prose prose-lg max-w-none text-[#1A1F2C]"
            dangerouslySetInnerHTML={{ __html: prepareContent(page.content) }}
          />
        </div>
      </section>
    </div>
  );
}
